import angular from "angular";
import ngAnimate from "angular-animate";
import ngSanitize from "angular-sanitize";
import ngTouch from "angular-touch";
import uiSelect from "ui-select";

import platformSelector from "../directives/platform-selector";

export default angular.module("controllers.metricsFilter", [
  ngAnimate,
  ngSanitize,
  ngTouch,
  uiSelect,
  platformSelector,
])
  .controller("MetricsFilterController", [
    "brands", // defined on rails view
    "platforms", // defined on rails view

    function(
      brands,
      platforms
    ) {
      this.brand = null;
      this.brands = brands;
      this.platform = null;
      this.platforms = platforms;
    },
  ])
  .name;



// WEBPACK FOOTER //
// ./app/web/packs/angular/controllers/metrics-filter-controller.js